export default {
  formattedPagination: `{{startOfPage}}-{{endOfPage}} of {{allResults}}`
};
